import { render, staticRenderFns } from "./AccountingGroupsTree.vue?vue&type=template&id=0c31453e&"
import script from "./AccountingGroupsTree.vue?vue&type=script&lang=js&"
export * from "./AccountingGroupsTree.vue?vue&type=script&lang=js&"
import style0 from "./AccountingGroupsTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports